import Text from '../../../../core/Text/Text'

export const ContactLink = () => {
  return (
    <Text
      as="a"
      href="mailto:support@arpeggi.io"
      css={{
        fontWeight: '$medium',
        textDecoration: 'underline',
        fontSize: 'inherit',
        color: 'inherit'
      }}
    >
      Click here to contact the Arpeggi team
    </Text>
  )
}
